import { loadStripe } from '@stripe/stripe-js'
import { STRIPE_PUBLISHABLE_KEY } from '../../constants'

export class StripeClient {
  public static loadStripe() {
    return loadStripe(STRIPE_PUBLISHABLE_KEY)
  }
}
